import { Clear } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

type AssetNode = {
  id?: string;
  mediaItemUrl?: string;
  title?: string;
};

type ImagePreviewProps = {
  node?: AssetNode;
  onClear?: () => void;
  style?: React.CSSProperties;
};

export const ImagePreview = ({ node, style, onClear }: ImagePreviewProps) => {
  if (!node?.mediaItemUrl) return null;

  return (
    <Tooltip title={node?.title}>
      <div
        style={{
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '20px',
          ...style,
        }}
      >
        {!!onClear ? (
          <Tooltip title="Clear Image">
            <IconButton
              size="small"
              onClick={onClear}
              sx={{
                position: 'absolute',
                top: '0',
                right: '0',
                zIndex: 1,
              }}
            >
              <Clear />
            </IconButton>
          </Tooltip>
        ) : null}
        <img
          src={node?.mediaItemUrl}
          style={{
            background: 'radial-gradient(circle, rgba(204,204,204,1) 0%, rgba(244,244,244,1) 60%)',
            maxWidth: '230px',
            maxHeight: '200px',
            width: 'auto',
            height: 'auto',
          }}
        />
      </div>
    </Tooltip>
  );
};
